const LOGIN_AS_TOKEN_KEY = 'jwt_login_as_access_token_dcra_app';

export const isLoggedInAsAdmin = (): boolean => {
  return !!localStorage.getItem(LOGIN_AS_TOKEN_KEY);
};
